import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './HrLine.scss'


const sizes = {
  sm: '14-24',
  md: '16-24',
}

// TODO replace 'sm', 'md'
const HrLine = ({ or, message, size, color, lineColor, mt, mb }) => {
  const lineClassName = cx(s.line, {
    [s[`${lineColor}Line`]]: lineColor,
  })

  return (
    <Box className={s.container} mt={mt} mb={mb}>
      <div className={lineClassName} />
      {
        Boolean(or || message) && (
          <Text
            className={s.text}
            size={sizes[size]}
            color={color}
            message={message || messages.or}
          />
        )
      }
      <div className={lineClassName} />
    </Box>
  )
}

HrLine.propTypes = {
  or: PropTypes.bool,
  size: PropTypes.oneOf([ 'sm', 'md' ]),
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(intlMessageShape),
  ]),
}

HrLine.defaultProps = {
  size: 'sm',
  mt: '24',
  mb: '24',
  color: 'gray-50',
}


export default HrLine
